import { all, takeLatest, call, put } from 'redux-saga/effects';
import MapActionTypes from './types';
import {
  queryFeatureLayerExtentSuccess,
  queryFeatureLayerExtentFailure,
  queryClusterExtentSuccess
} from './actions';
import { queryFeatuerLayerExtent } from 'services/map.service';

function* handleQueryFeatureLayerExtent(request: any) {
  try {
    const response: { count: number; extent: any } = yield call(
      queryFeatuerLayerExtent,
      request.payload.layer
    );
    if (response?.count > 0) {
      yield put(
        queryFeatureLayerExtentSuccess({
          extent: response.extent,
          count: response.count
        })
      );
    } else {
      yield put(queryFeatureLayerExtentSuccess({ noRecord: true }));
    }
  } catch (err) {
    yield put(queryFeatureLayerExtentFailure('Unable to query extent'));
  }
}

function* handleQueryClusterExtent(request: any) {
  try {
    const { layerView, objectId, isAggregate } = request.payload;
    const query = layerView.createQuery();
    if (isAggregate) {
      query.aggregateIds = [objectId];
    } else {
      query.objectIds = [objectId];
    }
    const response: { count: number; extent: any } = yield call(
      queryFeatuerLayerExtent,
      layerView,
      query
    );
    if (response?.count > 0) {
      yield put(
        queryClusterExtentSuccess({
          isAggregate,
          extent: response.extent
        })
      );
    }
  } catch (err) {
    // do nothing
  }
}

function* watchQueryFeatureLayerExtent() {
  yield takeLatest(
    MapActionTypes.QUERY_FEATURE_LAYER_EXTENT_START,
    handleQueryFeatureLayerExtent
  );
}

function* watchQueryClusterExtent() {
  yield takeLatest(
    MapActionTypes.QUERY_CLUSTER_EXTENT_START,
    handleQueryClusterExtent
  );
}

function* sagas() {
  yield all([
    call(watchQueryFeatureLayerExtent),
    call(watchQueryClusterExtent)
  ]);
}
export default sagas;
